/**
 * The 12x12 pixel-art woodchuck, drawn at any scale.
 */

// Woodchuck sprite — 12x12 pixel art, drawn at 4x scale = 48x48
const CHUCK_PIXELS = [
  "...BBBBBB...",
  "..BOOOOOOB..",
  ".BOOOOOOOOB.",
  ".BOKK.OKKOB.",
  ".BOKW.OKWOB.",
  ".BOOONNOOOB.",
  ".BOCCNNCCOB.",
  ".BOCCWWCCOB.",
  "..BOCCCCOB..",
  "..BOOOOOOB..",
  "...BDDDB...",
  "....BBB.....",
];
const CHUCK_COLORS = {
  O: 0xd4884a,
  B: 0x6b3a1f,
  C: 0xf5e6c8,
  K: 0x1a1a1a,
  W: 0xffffff,
  N: 0x1a1a1a,
  D: 0x8b5e3c,
};
const CHUCK_SCALE = 4;
/** Draw the 12x12 pixel woodchuck with its top-left at (ox, oy). */
export function drawChuck(g, ox, oy, scale = CHUCK_SCALE) {
  CHUCK_PIXELS.forEach((row, r) => {
    for (let c = 0; c < row.length; c++) {
      const color = CHUCK_COLORS[row[c]];
      if (color) {
        g.fillStyle(color);
        g.fillRect(ox + c * scale, oy + r * scale, scale, scale);
      }
    }
  });
}
